"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyPreviewContainer = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const strategy_preview_styles_1 = require("./strategy-preview.styles");
const strategy_tree_1 = require("./strategy-tree");
const product_tree_1 = require("../client/product-tree");
const components_1 = require("../components");
const store_1 = require("../../store");
const StrategyPreviewContainer = ({ isLoading, }) => {
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const { data, isLoading: loading, error, } = (0, product_tree_1.useProductTree)(selectedCatalogId, productTreeRootNodeId, { skip: isLoading });
    const isTreeLoading = isLoading || loading;
    return (react_1.default.createElement(strategy_preview_styles_1.StyledStrategyPreviewContainer, { className: (0, classnames_1.default)({ 'strategy-container--loading': isTreeLoading }) }, isTreeLoading && react_1.default.createElement(components_1.PreviewSkeleton, null), error && !isTreeLoading && react_1.default.createElement(components_1.Alert, { severity: "error" }, error.message), !isTreeLoading && productTreeRootNodeId && (react_1.default.createElement(strategy_tree_1.StrategyTree, { treeData: data }))));
};
exports.StrategyPreviewContainer = StrategyPreviewContainer;
exports.default = exports.StrategyPreviewContainer;
